<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.contractNum}}</span>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户名称</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同总金额</div>
          <div class="value">{{amountFormat(detail.contractTotalAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">关联回款计划</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractPlanFundDetail()">{{detail.planFundBatch}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">本次回款金额</div>
          <div class="value">{{amountFormat(detail.actualFundAmount)}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进记录" name="follow">
              <FollowAdd :targetId="detail.id" targetType="contractFundRecord" @success="handleAfterFollowAdd"></FollowAdd>
              <div style="height: 473px">
                <FollowList :targetId="detail.id" targetType="contractFundRecord" ref="followListRef"></FollowList>
              </div>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-form ref="updateForm" label-width="120px">
                <el-row :gutter="20" align="left">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="合同编号:">
                      <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail()">{{detail.contractNum}}</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户名称:">
                      <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="合同总金额:">
                      <span class="value">{{amountFormat(detail.contractTotalAmount)}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="关联回款计划:">
                      <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractPlanFundDetail()">{{detail.planFundBatch}}</el-link>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="本次回款金额:">
                      <span class="value">{{amountFormat(detail.actualFundAmount)}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="本次回款时间:">
                      <span class="value">{{detail.actualFundDate}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="支付方式:">
                      <span class="value">{{detail.payTypeDesc}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="回款银行:">
                      <span class="value">{{detail.bankDesc}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="创建人:">
                      <span class="value">{{detail.createUserName}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="创建时间:">
                      <span class="value">{{detail.createTime}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="contractFundRecord"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import OperateLogList from "@/views/crm/components/operateLogList";
import { amountFormat } from '@/utils/index'
import {queryContractFundRecordDetail} from "@/api/crm/fundRecord";

export default {
  name: "FundRecordDetail",
  data() {
    return {
      // 遮罩层
      amountFormat,
      loading: true,
      detail: {},
      activeName: "follow",
    };
  },
  components: {
    FollowList,
    FollowAdd,
    OperateLogList,
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的回款记录");
    }
  },
  watch: {
  },
  methods: {
    handleTabClick (tab) {
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryContractFundRecordDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
        } else {
          this.msgError("查询不到此回款记录");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    /** 详细按钮操作 */
    toContractDetail() {
      this.$router.push("/crm/contract/detail/" + this.detail.contractId);
    },
    /** 详细按钮操作 */
    toContractPlanFundDetail() {
      this.$router.push("/crm/plan-fund/detail/" + this.detail.contractPlanFundId);
    },
    /** 详细按钮操作 */
    toCustomerDetail() {
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    }
  }
};
</script>
